import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import * as React from "react";
import { Toaster } from "@patient-watch/ui/sonner";
import { DefaultCatchBoundary } from "../components/DefaultCatchBoundary";
import { NotFound } from "../components/NotFound";
import { GlucoseLocaleProvider, LanguageSwitch } from "../i18n/locale";
import { isMobile } from "react-device-detect";

export const Route = createRootRouteWithContext<{
    auth: {
        isAuthenticated: boolean;
        id: string;
        isAdmin: boolean;
        login: (id: string) => void;
    };
}>()({
    errorComponent: (props) => {
        return <DefaultCatchBoundary {...props} />;
    },
    notFoundComponent: () => <NotFound />,
    component: RootComponent,
});

function RootComponent() {
    return (
        <>
            <GlucoseLocaleProvider>
                <Toaster duration={isMobile ? 5000 : 6000} expand={true} />
                <LanguageSwitch className="top-3 right-3 z-50 fixed flex gap-2 bg-white/90 backdrop-blur p-1 rounded-lg" />
                <main className="pt-16 pb-8 min-h-screen background-light">
                    <Outlet />
                    <TanStackRouterDevtools position="bottom-right" />
                </main>
            </GlucoseLocaleProvider>
        </>
    );
}
